import { SuperAdminReviewsList } from "./SuperAdminReviewsList"

export const SuperAdminReviews = () => {
  return (
    <>
      <h1 className="text-[32px] font-bold">Recenzje Firm</h1>

      <div className="w-full">
        <SuperAdminReviewsList />
      </div>
    </>
  )
} 